import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-20 bg-sage text-white" data-id="element-173">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-174">
        <FadeIn data-id="element-175">
          <div className="text-center mb-12" data-id="element-176">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-177">
              ¿Por qué de repente nada funciona?
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-178"></div>
          </div>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed text-white/90" data-id="element-179">
          <FadeIn delay={0.2} data-id="element-180">
            <p data-id="element-181">
              Después de los 40, tu cuerpo deja de responder a las dietas
              clásicas. Reducir calorías o matarte haciendo cardio solo aumenta
              tu cortisol, lo que le indica a tu cerebro que debe acumular aún
              más grasa en el abdomen para "protegerte".
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-182">
            <p className="p-6 bg-forest/20 rounded-xl border border-white/10 shadow-inner" data-id="element-183">
              Vives en un ciclo infinito de fatiga crónica, inflamación
              sistémica y una niebla mental que no se quita ni con tres tazas de
              café. Tu cuerpo está en medio de una transición arquitectónica, y
              usar herramientas viejas solo está empeorando tus síntomas.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}